import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { vectors } from '../../data/vectors';
import styled from 'styled-components';

const Holder = styled.div`
`;

function Beard( { currentAvatar, features, images, path } ) {
  const [beardShape, setBeardShape] = useState(null);

  useEffect(() => {
    if ( features.faceshape === 'diamond' || features.faceshape === 'v') {
      setBeardShape( 'diamond__v' );
    } else if ( features.faceshape === 'long' || features.faceshape === 'square') {
      setBeardShape( 'long__square' );
    } else if ( features.faceshape === 'round' || features.faceshape === 'oval') {
      setBeardShape( 'round__oval' );
    }
  }, [features.faceshape]);

  if ( !features.beard || features.beard === 'stubble' || !beardShape ) { return null; }

  return (
    <Holder className={features.haircolour}>
      <img src={images( `${path}_beard_${features.beard}_${beardShape}_shadow.png` )} alt="beard shadow"/>
      <img src={images( `${path}_beard_${features.beard}_${beardShape}.png` )} alt="beard"/>
      {vectors[ `${currentAvatar}_beard_${features.beard}_${beardShape}_vector` ]}
    </Holder>
  )
}

Beard.propTypes = {
  features: PropTypes.object,
  images: PropTypes.func,
  path: PropTypes.string,
  currentAvatar: PropTypes.string.isRequired,
};

export default Beard;
